<template>
  <nav
    class="o-sidenav"
    :aria-label="$t('generic.sidenav.label')">
    <router-link
      :to="{
        name: 'home',
      }">
      <img
        v-if="logo"
        class="o-sidenav__logo"
        data-cy="DefaultSidenav__logo"
        :src="logo"
        :alt="config.name + ' - ' + $t('nav.home')" />
    </router-link>
    <ul class="o-sidenav__links">
      <template v-for="(entry, index) in navigation">
        <li
          v-if="entry.divider"
          :key="`divider-${index}`"
          class="o-sidenav__dividerWrapper"
          aria-hidden="true">
          <hr
            class="o-sidenav__divider"
            data-cy="DefaultSidenav__divider" />
        </li>
        <li
          v-else
          :key="`${entry.label}-route`">
          <router-link
            v-slot="{ href, navigate, isExactActive }"
            :to="entry.route"
            data-cy="DefaultSidenav__entry">
            <a
              class="o-sidenav__linkWrapper"
              :class="{ '-active': isExactActive }"
              :href="href"
              @click="navigate">
              <div class="o-sidenav__link">
                <SvgIcon
                  v-if="isExactActive"
                  :type="`menu_filled_${entry.icon}`" />
                <SvgIcon
                  v-else
                  :type="`menu_outline_${entry.icon}`" />
                <span class="t-caption1">{{ entry.label }}</span>
              </div>
            </a>
          </router-link>
        </li>
        <li
          v-for="(child, childIndex) in entry.children"
          :key="`${entry.label}-${childIndex}-route`">
          <router-link
            v-slot="{ href, navigate, isExactActive }"
            :to="child.route">
            <a
              class="o-sidenav__linkWrapper"
              :class="{ '-active': isExactActive }"
              :href="href"
              @click="navigate">
              <div class="o-sidenav__link -child">
                <template v-if="child.iconType === 'fontawesome'">
                  <FontAwesomeIcon
                    :icon="child.icon"
                    :size="18"
                    class="o-sidenav__fontawesomeIcon" />
                </template>
                <template v-else>
                  <SvgIcon
                    v-if="isExactActive"
                    :type="`menu_filled_${child.icon}`" />
                  <SvgIcon
                    v-else
                    :type="`menu_outline_${child.icon}`" />
                </template>
                <span class="t-caption1">{{ child.label }}</span>
              </div>
            </a>
          </router-link>
        </li>
      </template>
    </ul>
    <div class="o-sidenav__spacer" />
    <div class="o-sidenav__bottom">
      <LanguageSelector
        data-cy="DefaultSidenav__languageSelector">
        <template #default="language">
          <div
            class="o-sidenav__linkWrapper">
            <div class="o-sidenav__link t-caption1">
              <SvgIcon
                type="language" />
              {{ language.label }}
              <SvgIcon
                type="arrow_dropdown"
                class="s-languageDropdownIcon u-marginRight0 t-caption1" />
            </div>
          </div>
        </template>
      </LanguageSelector>
      <router-link
        v-slot="{ href, navigate, isActive }"
        :to="{
          name: 'profile.profile',
        }"
        data-cy="DefaultSidenav__profile">
        <div
          class="o-sidenav__linkWrapper"
          :class="{ '-active': isActive }">
          <a
            class="o-sidenav__link"
            :href="href"
            @click="navigate">
            <SvgIcon
              v-if="isActive"
              type="menu_filled_user" />
            <SvgIcon
              v-else
              type="menu_outline_user" />
            <span class="t-caption1">{{ $t('pages.my_profile') }}</span>
          </a>
        </div>
      </router-link>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'

import navigationMixin from './navigationMixin'

import FontAwesomeIcon from '@/components/FontAwesomeIcon.vue'

export default {
  mixins: [navigationMixin],
  computed: {
    ...mapGetters({
      config: 'auth/config',
    }),
    logo() {
      const settings = this.config.settings
      return settings.app_logo_inverse ? settings.app_logo_inverse : settings.app_logo
    },
  },
  components: {
    FontAwesomeIcon,
  },
}
</script>
